import { useState, useEffect } from 'react';
import { getFingerprint } from '../services/fingerprint';

export const useFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initFingerprint = async () => {
      try {
        const visitorId = await getFingerprint();
        setFingerprint(visitorId);
      } catch (error) {
        console.warn('Fingerprint loading failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initFingerprint();
  }, []);

  return { fingerprint, isLoading };
};
